import { render, staticRenderFns } from "./Italic.vue?vue&type=template&id=760ccd9c&"
import script from "./Italic.vue?vue&type=script&lang=js&"
export * from "./Italic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports